export default __webpack_public_path__ + "static/media/sticker-7.0088c4e4.png";